import { GETNET } from '../../constants/payment'
import { parseSsn } from '../../utils/ssn'
import { normalizeRegionName, regionCode } from '../addressParser'

export const parsePaymentMethod = (selectedPaymentOption, cardType) => {
  if (selectedPaymentOption) return selectedPaymentOption === 'debit' ? 'debitCard' : 'creditCard'
  return cardType === 'DEBIT' ? 'debitCard' : 'creditCard'
}

export const parsePaymentMethodToCardType = (selectedPaymentOption) => {
  return selectedPaymentOption === 'debit' ? 'DEBIT' : 'CREDIT'
}

export const parseCustomerData = (
  abandonedCartData,
  firstNameKey = 'name',
  lastNameKey = 'lastName',
  phoneValue = true,
  withoutDots = false
) => {
  const [firstName, lastName] =
    abandonedCartData.names?.trim().split(/ (.+)/) || []

  return {
    email: abandonedCartData.email,
    [firstNameKey]: firstName,
    [lastNameKey]: lastName,
    phone: phoneValue
      ? abandonedCartData.phone
      : `56${abandonedCartData.phone}`,
    ssn: withoutDots
      ? parseSsn(abandonedCartData.rut, true)
      : parseSsn(abandonedCartData.rut)
  }
}

export const parseShippingData = (address) => ({
  address: address.userAddress,
  city: address.district,
  deliveryInstructions: '',
  stateCode: `${regionCode[normalizeRegionName(address.region)]}`,
  zip: ''
})

export const parseSubscriptionData = (data, gateway) => {
  return {
    paymentGateway: gateway,
    referenceId: data.cartData.referenceId,
    paymentMethod: parsePaymentMethod(data.selectedPaymentOption),
    customerData: parseCustomerData(data.userInfo)
  }
}

export const parseCardData = (data) => {
  return {
    cardBrand: data.selectedPaymentCard.cardBrand,
    cardLastDigits: data.selectedPaymentCard.cardLastDigits,
    cardType: data.selectedPaymentCard.cardType || parsePaymentMethodToCardType(data.selectedPaymentOption)
  }
}

export const parsePaymentData = ({ data, gateway, useOneClick = false, forceNewPayment = false } = {
  data: {},
  gateway: '',
  useOneClick: false,
  forceNewPayment: false
}) => {
  return {
    customerData: parseCustomerData(data.userInfo),
    paymentMethod: parsePaymentMethod(data.selectedPaymentOption, data.selectedPaymentCard?.cardType),
    paymentGateway: gateway,
    referenceId: data.cartData.referenceId,
    cardData: useOneClick
      ? parseCardData(data)
      : undefined,
    shippingData: parseShippingData(data.addressInfo),
    installments: data.installments || undefined,
    amount: data.cartData.total,
    cms: data.ecommerceInfo.cms,
    forceNewPayment,
    useOneClick
  }
}

export const parseReferenceId = ({ gateway, referenceId }) => {
  if (gateway === GETNET) {
    return `${referenceId.slice(-10)}-payment`
  }
  return referenceId
}
